import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchNotFoundData } from "./notFound.service";
import { NotFoundData } from "./notFound.types";
import { RejectValueType } from "../redux/redux.types";
import { handleApiError } from "@/app/utils/handleApiError";

export const getNotFoundData = createAsyncThunk<
  NotFoundData,
  string,
  RejectValueType
>("notFound/getNotFoundData", async (slug, { rejectWithValue }) => {
  try {
    const response = await fetchNotFoundData(slug);
    return response.data;
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});
